import moment from 'moment';
// import config from '../config';
import searchRecommendApi from './api/searchRecommendApi';
/* ACTIONS */

export const OPENSEARCH_TOP10MOVIETITLELIST = 'OPENSEARCH/TOP10MOVIETITLELIST';
export const OPENSEARCH_TOP10SERIESTITLELIST = 'OPENSEARCH/TOP10SERIESTITLELIST';
export const OPENSEARCH_TOP10CATEGORYLIST = 'OPENSEARCH/TOP10CATEGORYLIST';
export const OPENSEARCH_TOP10WORDINGLIST = 'OPENSEARCH/TOP10WORDINGLIST';

export const SPICONFIG_LIST = 'SPICONFIG/LIST';
export const SPICONFIG_UPDATE = 'SPICONFIG/UPDATE';


export const VIEWERSESSION_SETTINGS = 'VIEWERSESSION/SETTINGS';
export const VIEWERSESSION_GETLIST = 'VIEWERSESSION/GETLIST';
export const VIEWERSESSION_GETUSERLIST = 'VIEWERSESSION/GETUSERLIST';
export const VIEWERSESSION_GETFILTERLIST = 'VIEWERSESSION/GETFILTERLIST';
export const VIEWERSESSION_GETSESSIONLIST = 'VIEWERSESSION/GETSESSIONLIST';
export const VIEWERSESSION_GETERRORLIST = 'VIEWERSESSION/GETERRORLIST';
export const INSPECTIONTIME_UPDATE = 'INSPECTIONTIME/UPDATE';
export const INDEPTHFILTER_UPDATE = 'INDEPTHFILTER/UPDATE';

/* ROUTE API */
// const SPICONFIG_LIST_ROUTE = '/broadcast';

const initialState = {
	viewersessionSettings: {userAccount: "",maxStep:0, currentStep: 0, timerange:[moment().startOf('hour').add(-1,'days').add(1,'hour').toISOString(), moment().startOf('hour').add(1,'hour').toISOString()]},
	inspectionTime: {day:7, till:moment().add(1,'hour').startOf('hour').toISOString()}
};

const getOpenSearchBuckets = (data) => {
	if(data && data.responses && data.responses[0] && data.responses[0].aggregations && data.responses[0].aggregations.results && data.responses[0].aggregations.results.buckets){
		return data.responses[0].aggregations.results.buckets;
	}else{
		return [];
	}
}



export default (state = initialState, action) => {
	switch (action.type) {
		case SPICONFIG_LIST:
			return {
				...state,
				spiconfigList: action.payload,
			};
		case SPICONFIG_UPDATE: // WHENEVER THAT IS UPDATED
			return {
				...state,
				spiCDNList: null
			};
		case INSPECTIONTIME_UPDATE:
			delete state.spiCDNList;
			delete state.indepthFilter;
			delete state.viewersessionFilterList;
			delete state.opensearchTop10MovieTitleList;
			delete state.opensearchTop10SeriesTitleList;
			delete state.opensearchTop10CategoryList;
			delete state.opensearchTop10WordingList;

			return {
				...state,
				inspectionTime: action.payload,
			};
		case VIEWERSESSION_SETTINGS:
			return {
				...state,
				viewersessionSettings: action.payload
			};
		case VIEWERSESSION_GETLIST:
			return {
				...state,
				viewersessionList: action.payload
			};
		case VIEWERSESSION_GETUSERLIST:
			return {
				...state,
				viewersessionUserList: action.payload,
			};
		case VIEWERSESSION_GETFILTERLIST:
			return {
				...state,
				viewersessionFilterList: action.payload,
			};
		case VIEWERSESSION_GETSESSIONLIST:
			return {
				...state,
				viewersessionSessionList: action.payload,
			};
		case VIEWERSESSION_GETERRORLIST:
			return {
				...state,
				viewersessionErrorList: action.payload,
			};
		case OPENSEARCH_TOP10MOVIETITLELIST:
			return {
				...state,
				opensearchTop10MovieTitleList: action.payload,
			};
		case OPENSEARCH_TOP10SERIESTITLELIST:
			return {
				...state,
				opensearchTop10SeriesTitleList: action.payload,
			};
		case OPENSEARCH_TOP10CATEGORYLIST:
			return {
				...state,
				opensearchTop10CategoryList: action.payload,
			};
		case OPENSEARCH_TOP10WORDINGLIST:
			return {
				...state,
				opensearchTop10WordingList: action.payload,
			};
		
		default:
			return state;
	}
};

export const spiconfigGetList = (organization) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/performanceConfig?account=${organization}`).then(data => {
			dispatch({
				type: SPICONFIG_LIST,
				payload: data
			});
			
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const spiconfigUpdate = (payload, paramStr) => {
	return dispatch => {
		return searchRecommendApi.patch(`/statistic/performanceConfig?${paramStr}`, payload).then(data => {
			dispatch({
				type: SPICONFIG_UPDATE
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};




export const indepthFilterUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INDEPTHFILTER_UPDATE,
			payload: data
		});
	};
};

export const inspectionTimeUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INSPECTIONTIME_UPDATE,
			payload: data
		});
	};
};

export const viewersessionUpdateSettings = (data) => {
	return dispatch => {
		dispatch({
			type: VIEWERSESSION_SETTINGS,
			payload: data
		});
	};
};

export const viewersessionGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/listAccountName?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetUserList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETUSERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetFilterList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETFILTERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetSessionList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETSESSIONLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetErrorList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic/listErrorSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETERRORLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const opensearchTop10MovieTitle = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTop10SearchMovie`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10MOVIETITLELIST,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10SeriesTitle = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTop10SearchSeries`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10SERIESTITLELIST,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10Category = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTop10SearchCategory`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10CATEGORYLIST,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchTop10Wording = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTop10SearchKeyword`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10WORDINGLIST,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

